import { Directive } from '@angular/core';
import {  Output, Input, EventEmitter, HostBinding, HostListener } from '@angular/core';
@Directive({
  selector: '[appDnd]'
})

export class DndDirective {

@HostBinding('class.fileover') fileOver:boolean;
@Output() fileDropped = new EventEmitter<any>();
  constructor() { }
  @HostListener('dragover', ['$event']) onDragOver(evt){
    
    evt.preventDefault();
    evt.stopPropagtion();
    this.fileOver=true;
    
  }
  @HostListener('dragleave', ['$event']) public onDragLeave(evt){
    evt.preventDefault();
    evt.stopPropagtion();
    
  }
  @HostListener('drag', ['$event']) public ondrop(evt){
    
    evt.preventDefault();
    evt.stopPropagtion();
    this.fileOver =false;
    const files = evt.datatransfer.files;
    if(files.length > 0){
      this.fileDropped.emit(files)
      
    }
    
  }
  
}
